// ------------------------------------
// Constants
// ------------------------------------
export const POLICY_INSIGHTS_CONFLICTS_GET_REQUEST =
  "POLICY_INSIGHTS_CONFLICTS_GET_REQUEST";
export const POLICY_INSIGHTS_CONFLICTS_GET_REQUEST_SUCCESS =
  "POLICY_INSIGHTS_CONFLICTS_GET_REQUEST_SUCCESS";
export const POLICY_INSIGHTS_CONFLICTS_GET_REQUEST_FAILURE =
  "POLICY_INSIGHTS_CONFLICTS_GET_REQUEST_FAILURE";
export const POLICY_INSIGHTS_CONFLICTS_RESET =
  "POLICY_INSIGHTS_CONFLICTS_RESET";
export const POLICY_INSIGHTS_CONFLICTS_DISMISS_OPTIMISTIC =
  "POLICY_INSIGHTS_CONFLICTS_DISMISS_OPTIMISTIC";
export const POLICY_INSIGHTS_CONFLICTS_DISMISS_REVERT =
  "POLICY_INSIGHTS_CONFLICTS_DISMISS_REVERT";
export const POLICY_INSIGHTS_CONFLICTS_DISMISS_CONFIRMED =
  "POLICY_INSIGHTS_CONFLICTS_DISMISS_CONFIRMED";

// ------------------------------------
// Actions
// ------------------------------------
// `append` is true for infinite-scroll page fetches after the first — the
// reducer merges `data.conflicts` onto the existing list instead of replacing.
export function request({ page, limit, append = false } = {}) {
  return {
    type: POLICY_INSIGHTS_CONFLICTS_GET_REQUEST,
    page,
    limit,
    append,
  };
}

export function requestSuccess(data, { append = false } = {}) {
  return {
    type: POLICY_INSIGHTS_CONFLICTS_GET_REQUEST_SUCCESS,
    data,
    append,
  };
}

export function requestFailure(error, { append = false } = {}) {
  return {
    type: POLICY_INSIGHTS_CONFLICTS_GET_REQUEST_FAILURE,
    error,
    append,
  };
}

export function reset() {
  return { type: POLICY_INSIGHTS_CONFLICTS_RESET };
}

export function dismissOptimistic(id) {
  return { type: POLICY_INSIGHTS_CONFLICTS_DISMISS_OPTIMISTIC, id };
}

// Re-insert a conflict that was optimistically dismissed but whose PATCH
// failed. Caller passes the original conflict object so we can restore both
// the row and the summary counter at the position the conflict had before.
export function dismissRevert(conflict, index) {
  return { type: POLICY_INSIGHTS_CONFLICTS_DISMISS_REVERT, conflict, index };
}

// Fired when the ack PATCH for `id` returns successfully. The conflict was
// already removed by dismissOptimistic — this clears the id from the
// pending-dismiss guard set so future GET responses are no longer filtered
// against it.
export function dismissConfirmed(id) {
  return { type: POLICY_INSIGHTS_CONFLICTS_DISMISS_CONFIRMED, id };
}
